import request from '@/utils/request'
// 查询赞誉详情
export function getEvaluateDetail(data) {
  return request({
    url: '/health-evaluation/reputation/comment/page/detail',
    method: 'post',
    data
  })
}
export function getReputationList(data) {
  return request({
    url: '/health-doctor-assistant/reputation/page/list',
    method: 'post',
    data
  })
}
//【新】健管端-某患者赞誉总数量统计
export function getReputationCount(data) {
  return request({
    url: '/health-evaluation/reputation/comment/count',
    method: 'get',
    params: data
  })
}
//删除感谢信

export function deleteThankLetter(data) {
  return request({
    url: '/health-evaluation/evaluation/thankLetters/delete',
    method: 'get',
    params: data
  })
}
